import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { UserFacade } from '@app/store/user';
import { Bind } from 'primeng/bind';
import { Avatar } from 'primeng/avatar';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Bind, Avatar, AsyncPipe],
})
export class UserInfoComponent {
    private userFacade = inject(UserFacade);

    readonly user$ = this.userFacade.user$;
}
